import React from "react"
import ContentPromoSection from "../../components/partner-program/content-promo"
import { HeroOverlay } from "../../components/partner-program/hero.style"
import MappingSDKs from "../../components/partner-program/mapping-sdk"
import OurCommitment from "../../components/partner-program/our-commitment"
import Overview from "../../components/partner-program/overview"
import PartnerGallery from "../../components/partner-program/partner-gallery"
import PartnerPDF from "../../components/partner-program/partner-pdf"
import PartnerTypesTiers from "../../components/partner-program/partner-types-tiers"
import Stats from "../../components/partner-program/stats"
import useHeroImages from "../../components/partner-program/useHeroImages"
import Footer from "../../components/shared/footer"
import Hero from "../../components/shared/hero"
import Layout from "../../components/shared/layout"
import PartnerForm from "../../components/shared/partner-form"
import SEO from "../../components/shared/seo"

const PartnerProgramPage = ({ location }) => {
  const images = useHeroImages()

  return (
    <Layout location={location}>
      <SEO
        title="Partner Program"
        description="Partner with Mappedin as we unlock incredible indoor mapping experiences and work together to deliver better digital results for the physical environment."
      />
      <Hero title="Partner Program" sizes={images} overlayStyle={HeroOverlay} />
      <Overview />
      <Stats />
      <OurCommitment />
      <PartnerTypesTiers />
      <PartnerGallery />
      <PartnerPDF />
      <MappingSDKs />
      <ContentPromoSection />
      <PartnerForm />
      <Footer />
    </Layout>
  )
}

export default PartnerProgramPage
